import { render, staticRenderFns } from "./GroupMembershipTable.vue?vue&type=template&id=30d590db&scoped=true&"
import script from "./GroupMembershipTable.vue?vue&type=script&lang=js&"
export * from "./GroupMembershipTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d590db",
  null
  
)

export default component.exports